"use strict";

require("./_article-spotify-block");